(function(){
  'use strict';
  var CATEGORY_KEY='dulchefs_category';
  var seed=sessionStorage.getItem('dulchefs_random_seed')||String(Math.random());
  sessionStorage.setItem('dulchefs_random_seed',seed);
  function selectedCategories(){
    var raw=sessionStorage.getItem(CATEGORY_KEY)||'';
    if(!raw)return[];
    try{var parsed=JSON.parse(raw);if(Array.isArray(parsed))return parsed.filter(function(c){return c!=='ar'&&c!=='reparto'&&c!=='personalizable'}).slice(-1)}catch(error){}
    return ['ar','reparto','personalizable'].includes(raw)?[]:[raw];
  }
  function extraCategories(){try{return JSON.parse(sessionStorage.getItem('dulchefs_directory_extras')||'[]').filter(function(c){return ['reparto','ar','personalizable'].includes(c)})}catch(e){return []}}
  function initControls(root){
    var toggle=root.querySelector('[data-dc-order-toggle]'),options=root.querySelector('[data-dc-order-options]'),label=root.querySelector('[data-dc-order-label]');
    var names={nearby:'Cercanía',rating:'Mejor valoradas',name:'De la A a la Z'};
    function close(){options.hidden=true;toggle.setAttribute('aria-expanded','false')}
    function paintControls(){
      var extras=extraCategories(),sort=sessionStorage.getItem('dulchefs_directory_sort')||'';
      root.querySelectorAll('[data-dc-extra]').forEach(function(b){b.setAttribute('aria-pressed',String(extras.includes(b.dataset.dcExtra)))});
      label.textContent=names[sort]||'Ordenar por';
      toggle.classList.toggle('has-selection',!!names[sort]);
      root.querySelectorAll('[data-dc-sort]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.dcSort===sort))});
      var status=root.querySelector('[data-dc-sort-status]'),location=null;
      try{location=JSON.parse(localStorage.getItem('dulchefs_location_v2'))}catch(e){}
      status.hidden=root.hasAttribute('data-dc-standard-collection')||sort!=='nearby'||!!(location&&Number.isFinite(location.lat)&&Number.isFinite(location.lng));
      status.textContent=status.hidden?'':'Selecciona tu ubicación en la cabecera para ordenar por cercanía.';
    }
    toggle.addEventListener('click',function(){if(sessionStorage.getItem('dulchefs_directory_sort')){sessionStorage.removeItem('dulchefs_directory_sort');paintControls();close();document.dispatchEvent(new CustomEvent('dulchefs:sortchange'));return;}var open=options.hidden;options.hidden=!open;toggle.setAttribute('aria-expanded',String(open))});
    root.querySelectorAll('[data-dc-extra]').forEach(function(b){b.addEventListener('click',function(){var extras=extraCategories(),key=b.dataset.dcExtra;extras=extras.includes(key)?extras.filter(function(c){return c!==key}):extras.concat(key);sessionStorage.setItem('dulchefs_directory_extras',JSON.stringify(extras));paintControls();setCategories(root,selectedCategories())})});
    root.querySelectorAll('[data-dc-sort]').forEach(function(b){b.addEventListener('click',function(){sessionStorage.setItem('dulchefs_directory_sort',b.dataset.dcSort);paintControls();close();document.dispatchEvent(new CustomEvent('dulchefs:sortchange'))})});
    document.addEventListener('click',function(e){if(!toggle.parentElement.contains(e.target))close()});
    root.addEventListener('keydown',function(e){if(e.key==='Escape'&&!options.hidden){close();toggle.focus()}});
    document.addEventListener('dulchefs:locationchange',paintControls);
    paintControls();
  }
  function rank(value){
    var hash=2166136261,text=String(value)+seed;
    for(var i=0;i<text.length;i++){hash^=text.charCodeAt(i);hash=Math.imul(hash,16777619)}
    return hash>>>0;
  }
  function resetStart(nav){
    nav.scrollLeft=0;
    requestAnimationFrame(function(){nav.scrollLeft=0;requestAnimationFrame(function(){nav.scrollLeft=0})});
  }
  function orderItems(root,nav){
    var first=['panaderia','tartas','merengue','chocolate'],items=Array.from(nav.children);
    var fixed=items.filter(function(item){return first.includes(item.dataset.dcCategory)}).sort(function(a,b){return first.indexOf(a.dataset.dcCategory)-first.indexOf(b.dataset.dcCategory)});
    var rest=items.filter(function(item){return !first.includes(item.dataset.dcCategory)});
    if(root.dataset.randomOrder==='true')rest.sort(function(a,b){return rank(a.dataset.dcOrderKey||'')-rank(b.dataset.dcOrderKey||'')});
    fixed.concat(rest).forEach(function(item){nav.appendChild(item)});
    resetStart(nav);
  }
  function paint(root,categories){
    root.querySelectorAll('[data-dc-category]').forEach(function(link){
      var selected=categories.includes(link.dataset.dcCategory);
      link.classList.toggle('dc-category-selected',selected);
      link.setAttribute('aria-pressed',selected?'true':'false');
    });
    root.querySelectorAll('[data-dc-dietary-choice]').forEach(function(choice){
      var prefix=choice.dataset.dcDietaryChoice+'-';
      var selected=categories.some(function(category){return category.indexOf(prefix)===0});
      choice.classList.toggle('dc-category-selected',selected);
      choice.querySelector('[data-dc-dietary-parent]').setAttribute('aria-pressed',selected?'true':'false');
    });
  }
  function setCategories(root,categories){
    var unique=Array.from(new Set((categories||[]).filter(Boolean).slice(-1)));
    sessionStorage.setItem(CATEGORY_KEY,JSON.stringify(unique));
    paint(root,unique);
    document.dispatchEvent(new CustomEvent('dulchefs:categorychange',{detail:{categories:unique.concat(extraCategories())}}));
  }
  function initSticky(root){
    if(root.dataset.stickyMode!=='sticky')return;
    var sticky=root.querySelector('[data-dc-filter-sticky]'),start=0;
    if(!sticky)return;
    function measure(){
      var fixed=sticky.classList.contains('is-fixed');
      if(fixed){sticky.classList.remove('is-fixed');root.classList.remove('dc-search-fixed')}
      root.style.setProperty('--dc-sticky-height',sticky.offsetHeight+'px');
      start=sticky.getBoundingClientRect().top+window.scrollY;
      if(fixed){sticky.classList.add('is-fixed');root.classList.add('dc-search-fixed')}
    }
    function update(){
      var fixed=window.scrollY>=start;
      sticky.classList.toggle('is-fixed',fixed);
      root.classList.toggle('dc-search-fixed',fixed);
      if(fixed)root.style.setProperty('--dc-sticky-height',sticky.offsetHeight+'px');
    }
    measure();update();
    if(window.ResizeObserver)new ResizeObserver(function(){root.style.setProperty('--dc-sticky-height',sticky.offsetHeight+'px')}).observe(sticky);
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',function(){measure();update()},{passive:true});
  }
  function init(root){
    if(root.dataset.dcReady==='true')return;
    root.dataset.dcReady='true';
    var nav=root.querySelector('.dc-market-header__categories');
    if(!nav)return;
    orderItems(root,nav);
    var previous=window.DCFilters.inventory,inventory=previous?previous.products:[],complete=previous?previous.complete:false;
    function available(){
      var selected=selectedCategories(),extras=extraCategories(),changed=false;
      function has(cat,others){return inventory.some(function(p){return window.DCFilters.match(p,cat)&&others.every(function(c){return window.DCFilters.match(p,c)})})}
      if(complete){
        var valid=selected.filter(function(c){return has(c,[])});changed=valid.length!==selected.length;selected=valid;
      }
      root.querySelectorAll('[data-dc-category],[data-dc-dietary-option]').forEach(function(el){window.DCFilters.hide(el,!has(el.dataset.dcCategory||el.dataset.dcDietaryOption,extras))});
      root.querySelectorAll('[data-dc-dietary-choice]').forEach(function(el){window.DCFilters.hide(el,!Array.from(el.querySelectorAll('[data-dc-dietary-option]')).some(function(o){return !o.hasAttribute('data-dc-filter-empty')}))});
      root.querySelectorAll('[data-dc-extra]').forEach(function(el){var c=el.dataset.dcExtra;window.DCFilters.hide(el,false);el.setAttribute('aria-pressed',String(extras.includes(c)))});
      if(changed)setCategories(root,selected);
      paint(root,selected);
    }
    document.addEventListener('dulchefs:filterinventory',function(e){inventory=e.detail.products;complete=e.detail.complete;available()});
    document.addEventListener('dulchefs:categorychange',available);
    available();

    window.addEventListener('pageshow',function(){resetStart(nav)});
    function closeChoices(except){
      root.querySelectorAll('[data-dc-dietary-choice]').forEach(function(choice){
        if(choice===except)return;
        choice.classList.remove('is-open');
        choice.querySelector('[data-dc-dietary-options]').hidden=true;
        choice.querySelector('[data-dc-dietary-parent]').setAttribute('aria-expanded','false');
      });
    }
    root.querySelectorAll('[data-dc-category]').forEach(function(link){
      link.setAttribute('aria-pressed','false');
      link.addEventListener('click',function(event){
        event.preventDefault();
        var category=link.dataset.dcCategory||'',categories=selectedCategories(),index=categories.indexOf(category);
        if(!category)return;
        categories=index===-1?[category]:[];closeChoices();
        setCategories(root,categories);
      });
    });
    root.querySelectorAll('[data-dc-dietary-choice]').forEach(function(choice){
      var parent=choice.querySelector('[data-dc-dietary-parent]'),options=choice.querySelector('[data-dc-dietary-options]'),prefix=choice.dataset.dcDietaryChoice+'-';
      parent.setAttribute('aria-pressed','false');
      parent.addEventListener('click',function(){
        var categories=selectedCategories(),active=categories.find(function(category){return category.indexOf(prefix)===0});
        if(active){setCategories(root,categories.filter(function(category){return category!==active}));closeChoices();return}
        var open=!choice.classList.contains('is-open');
        closeChoices(choice);choice.classList.toggle('is-open',open);options.hidden=!open;parent.setAttribute('aria-expanded',open?'true':'false');
      });
      options.querySelectorAll('[data-dc-dietary-option]').forEach(function(option){
        option.addEventListener('click',function(){
          var category=option.dataset.dcDietaryOption,categories=selectedCategories().filter(function(item){return item.indexOf(prefix)!==0});
          if(!category)return;
          categories=[category];setCategories(root,categories);choice.classList.remove('is-open');options.hidden=true;parent.setAttribute('aria-expanded','false');
        });
      });
    });
    document.addEventListener('click',function(event){if(!event.target.closest('[data-dc-dietary-choice]'))closeChoices()});
    document.addEventListener('dulchefs:removecategory',function(event){var category=event.detail&&event.detail.category;setCategories(root,selectedCategories().filter(function(item){return item!==category}))});
    document.addEventListener('dulchefs:clearcategory',function(){setCategories(root,[])});
    sessionStorage.setItem(CATEGORY_KEY,JSON.stringify(selectedCategories()));
    initControls(root);
    paint(root,selectedCategories());
    initSticky(root);
  }
  function start(scope){(scope||document).querySelectorAll('[data-dc-filter-carousel]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){start(document)});else start(document);
  document.addEventListener('shopify:section:load',function(event){start(event.target)});
})();
